import type { StorePageConfig } from '@/app/(football)/[team]/store/_context/types';

/**
 * Steelers Store Config (Placeholder)
 *
 * 스토어 기능이 아직 없는 팀을 위한 placeholder 설정
 * features.hasStore = false로 접근 제어
 */
export const steelersConfig: StorePageConfig = {
  titleSection: {
    title: '스토어',
    highlight: '오직 팬카드에서만!',
    description: '한정판 디지털 에디션을 만나보세요.',
  },
};
